import 'bootstrap';
import {onDOMContentLoaded} from "bootstrap/js/src/util";
window.bootstrap = require('bootstrap');

import './scss/custom.scss';
import lozad from 'lozad'

// for old code
import $ from "jquery";
window.$ = $;

// bs expansion of components
import './js/components/bs-collapse/index'
import {Popover} from "bootstrap";

window.lozadObserver = lozad(); // lazy loads elements with default selector as '.lozad'

onDOMContentLoaded(() => {
    window.lozadObserver.observe();

    const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
    const popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
        return new Popover(popoverTriggerEl);
    });
});
